import React from 'react';

export default function ChatBubbleIcon(props) {
  return (
    <div className={props.className} alt={props.alt}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2
        }}
        viewBox="0 0 1571 1363"
        {...props}
      >
        <path
          d="M1242.65 1706.71c-22.27 0-43.51 9.42-58.46 25.92l-94.95 104.78a121.782 121.782 0 0 1-91.208 40.01 121.771 121.771 0 0 1-90.56-41.46l-85.443-97.38a93.628 93.628 0 0 0-70.362-31.87h-21.079c-190.83 0-345.76-154.93-345.76-345.76V922.376c0-190.83 154.93-345.76 345.76-345.76h832.532c190.83 0 345.76 154.93 345.76 345.76v438.574c0 190.83-154.93 345.76-345.76 345.76h-320.47Zm-260.479 12.22a22.972 22.972 0 0 0 17.065 7.82 22.933 22.933 0 0 0 17.184-7.54c25.18-27.78 68.97-76.11 68.97-76.11a212.208 212.208 0 0 1 157.26-69.72h320.47c117.25 0 212.43-95.19 212.43-212.43V922.376c0-117.242-95.18-212.427-212.43-212.427H730.588c-117.241 0-212.427 95.185-212.427 212.427v438.574c0 117.24 95.186 212.43 212.427 212.43h21.08a226.965 226.965 0 0 1 170.584 77.26s37.275 42.49 59.919 68.29Z"
          style={{
            fill: props.color
          }}
          transform="rotate(-6.881 -3427.68 3884.293)"
        />
        <circle
          cx={766.499}
          cy={297.486}
          r={51.876}
          style={{
            fill: props.color
          }}
          transform="rotate(-7.16 1191.322 10052.125) scale(2.16515)"
        />
        <circle
          cx={766.499}
          cy={297.486}
          r={51.876}
          style={{
            fill: props.color
          }}
          transform="rotate(-7.16 1037.438 7592.46) scale(2.16515)"
        />
        <circle
          cx={766.499}
          cy={297.486}
          r={51.876}
          style={{
            fill: props.color
          }}
          transform="matrix(2.14826 -.26986 .26986 2.14826 -633 147.45)"
        />
      </svg>
    </div>
  );
}
